import React from 'react'
import ListMexHeader from './ListMexTable/ListMexHeader'
import ListMexRow from './ListMexTable/ListMexRow'

function ListMexTable(props) {
    const {listMex, loading, setType} = props

    return (
        <div className='ListMexTable'>
            <table className="table table-borderless table-striped">
                <ListMexHeader />
                <tbody className="ListMexRow">
                    {
                        !!listMex && listMex.length > 0 && listMex.map((item, i) => {
                            return <ListMexRow
                                key={i}
                                index={i}
                                item={item}
                                setType={setType}
                            />
                        })
                    }
                    {
                        !loading && (!listMex || listMex.length === 0) &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ListMexTable